import { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Paper from "@mui/material/Paper";
import {
  Box,
  IconButton,
  MenuItem,
  Pagination,
  Select,
  Typography,
} from "@mui/material";
import Row from "./Row";
import ShimmerLoader from "../../CommonComponents/Loader/ShimmerLoader";
import {
  PAGE_PER_COUNT_OPTIONS,
  TABLE_CONSTANTS,
} from "../../../constants/lang";
import { TableStyles } from "./TableStyles";
import { CardStyles } from "./CardStyles";

export default function CollapsibleTable({
  totalPages = 0,
  headings = [],
  rows = [],
  isDownIconVisible = false,
  totalCount = 5,
  detailsHeading = [],
  pageNo = 1,
  pageSize = 10,
  setPageNo = () => { },
  setPageSize = () => { },
  sxHeight = "87vh",
  showPagination = true,
  loading = false,
  noDataComponent = null,
  sxMobileHeight = "auto",
  openProductDetails,
  viewDetailsShow = false
}) {
  const handlePageChange = (event, value) => {
    console.log("event", event);
    setPageNo(value);
  };

  const handleRowsPerPageChange = (event) => {
    setPageSize(event.target.value);
    setPageNo(1);
  };
  const [openStates, setOpenStates] = useState({});

  const toggleOpen = (index) => {
    setOpenStates((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    setOpenStates({});
  }, [rows]);

  let filteredOptions = PAGE_PER_COUNT_OPTIONS.filter(
    (option) => option <= totalCount
  );

  // Ensure totalCount is included if it's greater than any existing filtered option
  if (
    !filteredOptions.includes(totalCount) &&
    totalCount > Math.max(...filteredOptions, 0)
  ) {
    filteredOptions.push(parseInt(totalCount));
  }
  return (
    <>
      <TableStyles>
        <Paper className='table-paper'>
          <TableContainer
            className='table-container'
            sx={{
              height: sxHeight,
            }}
          >
            <Table stickyHeader aria-label='collapsible table'>
              <TableHead className='table-head-class'>
                <TableRow hover>
                  { !rows?.length ? "" : 
                  headings?.map((data, idx) => (
                    <TableCell key={idx} className='table-head' align='left'>
                      {data}
                    </TableCell>
                  ))}
                  {isDownIconVisible && <TableCell className='table-head' />}
                </TableRow>
              </TableHead>
              {!loading && !rows?.length && (
                <div className='table-body'>{noDataComponent}</div>
              )}
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={headings?.length + (isDownIconVisible ? 1 : 0)} align="center">
                      <ShimmerLoader />
                    </TableCell>
                  </TableRow>
                ) : (
                  rows?.map((row, index) => (
                    <Row
                      headings={headings}
                      detailsHeading={detailsHeading}
                      isDownIconVisible={isDownIconVisible}
                      key={index}
                      row={row}
                    />
                  ))
                )}
              </TableBody>
            </Table>
            {showPagination && rows?.length > 0 && (
              <div className='pagination-container'>
                <div className='pagesize'>
                  {TABLE_CONSTANTS.SHOWING}
                  <Select
                    className='select-input'
                    value={pageSize}
                    onChange={handleRowsPerPageChange}
                  >
                    {filteredOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                  {TABLE_CONSTANTS.OF} {totalCount}
                </div>
                <Pagination
                  siblingCount={0}
                  boundaryCount={2}
                  count={totalPages}
                  page={pageNo}
                  onChange={handlePageChange}
                  variant='outlined'
                  shape='rounded'
                />
              </div>
            )}
          </TableContainer>
        </Paper>
      </TableStyles>
      <CardStyles>
        <Box
          className='card-container'
          height={sxMobileHeight}
          overflow={"scroll"}
        >
          {loading ? (
            <ShimmerLoader />
          ) : !loading && !rows?.length ? (
            <div className='table-body'>{noDataComponent}</div>
          ) : (
            rows?.map((rowData, j) => {
              const isOpen = openStates[j] || false;
              const myData = Object.keys(rowData);
              return (
                <Box className='card-box' key={j}>
                  <Box
                    marginBottom='8px'
                    display='flex'
                    justifyContent={"space-between"}
                    alignItems={"center"}
                  >
                    <Typography
                      component="div"
                      className={`${typeof rowData[myData?.[0]] === "string" && "order-no"}`}
                    >
                      {rowData?.[myData[0]]}
                    </Typography>
                    {headings
                      ?.filter((data1) => data1 === "Action")
                      .map((i) => (
                        <Box className='content' key={i}>
                          {rowData?.["action"]}
                        </Box>
                      ))}
                  </Box>
                  {headings?.map((data, i) =>
                    i !== 0 && typeof data === "string" && !data.includes("Action") && (
                      <Box className='content' key={i}>
                        <Typography component="div" className='label'>{data}: </Typography>
                        {viewDetailsShow && i === headings?.length - 2 ? (
                          <Box className='mobile-view-deatls'>
                            <Typography component="div" className='value'>
                              {rowData[myData[i]]}
                            </Typography>
                            <Typography component="div" className='deatils-value' onClick={() => openProductDetails?.(j)}>
                              View Details
                            </Typography>
                          </Box>
                        ) : (
                          <Typography component="div" className='value'>
                            {rowData[myData[i]]}
                          </Typography>
                        )}
                      </Box>
                    )
                  )}
                  {isOpen && (
                    <Box className='details'>
                      <Typography component="div" className='title'>Product variant</Typography>
                      {rowData?.productDetails?.map((item, k) => (
                        <Box className='product' key={k}>
                          <Typography component="div">{item[Object.keys(item)[0]]}</Typography>
                          <Box className='content-boxes'>
                            {detailsHeading?.map(
                              (heading, i) =>
                                i !== 0 &&
                                i !== 1 && (
                                  <Box className='content' key={i}>
                                    <Typography component="div" className='label'>
                                      {heading}:{" "}
                                    </Typography>
                                    <Typography component="div" className='value'>
                                      {item[Object.keys(item)[i]]}
                                    </Typography>
                                  </Box>
                                )
                            )}
                          </Box>
                        </Box>
                      ))}
                      <Box className='total-section'>
                        <Typography component="div" className='total-text'>
                          Total order amount
                        </Typography>
                        <Typography component="div" className='total-value'>
                          {rowData?.pending_amount}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  {isDownIconVisible && (
                    <Box className='show-more-section'>
                      <Typography
                        component="div"
                        onClick={() => toggleOpen(j)}
                        className='show-more'
                      >
                        View {isOpen ? "less" : "details"}
                      </Typography>
                      <IconButton
                        className='down-icon'
                        aria-label='expand row'
                        size='small'
                        onClick={() => toggleOpen(j)}
                      >
                        {isOpen ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                    </Box>
                  )}
                </Box>
              );
            })
          )}
        </Box>
        {showPagination && rows?.length > 0 && (
          <div className='pagination-container'>
            <div className='pagesize'>
              {TABLE_CONSTANTS.SHOWING}
              <Select
                className='select-input'
                value={pageSize}
                onChange={handleRowsPerPageChange}
              >
                {filteredOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
              {TABLE_CONSTANTS.OF} {totalCount}
            </div>
            <Pagination
              siblingCount={0}
              boundaryCount={2}
              count={totalPages}
              page={pageNo}
              onChange={handlePageChange}
              variant='outlined'
              shape='rounded'
            />
          </div>
        )}
      </CardStyles>
    </>
  );
}
